import { SagaIterator } from "redux-saga"
import { call, put, fork, take, takeEvery, cancel, cancelled } from "redux-saga/effects"
import * as templateTimeslotActions from "app/redux/timeslots/timeslots.actions"
import { createWebSocketConnectionForTemplateTimeslots } from "app/webSockets/webSockets"
import { createSocketChannel, joinRoom, whenConnected } from "app/webSockets/channels"
import { Socket } from "socket.io-client"
import { TemplateTimeslotsChannelPayload } from "./templateTimeslotsChannel.reducer"
import * as actions from "./templateTimeslotsChannel.actions"

function* writeAndReadSocket(socket: Socket, payload: TemplateTimeslotsChannelPayload) {
  const readerChannel = yield call(createSocketChannel, socket)
  try {
    joinRoom(socket, payload)
    yield call(whenConnected, socket)
    yield put(actions.connectionTemplateTimeslotsChannelSuccess())
    while (true) {
      const { timeslots } = yield take(readerChannel)
      yield put(templateTimeslotActions.getTimeslotsByIdSuccess(timeslots))
    }
  } catch (error) {
    yield put(actions.connectionTemplateTimeslotsChannelFail(error))
  } finally {
    if (yield cancelled()) {
      socket.disconnect()
      readerChannel.close()
      yield put(actions.disconnectTemplateTimeslotsChannelSuccess())
    } else {
      yield put(actions.disconnectTemplateTimeslotsChannelFail(new Error("disconnected")))
    }
  }
}

function* listen(action: actions.ConnectTemplateTimeslotsChannelAction) {
  const socket = yield call(createWebSocketConnectionForTemplateTimeslots)
  const w = yield fork(writeAndReadSocket, socket!, action.payload)

  yield take(actions.Types.DISCONNECT)
  yield cancel(w)
}

export default function* templateTimeslotsChannelSaga(): SagaIterator {
  yield takeEvery([actions.Types.CONNECT], listen)
}
